import React from "react";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import "../src/styles.css";
import Home from "./pages/Home";
import QueroVender from "./pages/QueroVender"
//import Login from "./pages/Login";
import QueroComprar from "./pages/QueroComprar";
import Login from "./pages/login";
import Index from "./pages/index";
import AvaliacaoIndex from './pages/Painel/avaliacaoIndex';
import PropostaIndex from './pages/Painel/propostaIndex';
import BankDataForm from './components/BankDataForm';
import ConfigIndex from "./pages/Painel/configIndex"
import EditUserIndex from "./pages/Painel/editUserIndex"
import IndexUser from "./pages/IndexUser"
import PropostaUserIndex from "./pages/Painel/Usuario/propostaUserIndex"
import ForgotPassword from "./pages/forgetPassowrd"
import ResetPassword from "./pages/ResetPassword"
import ProtectedRoute from "../src/auth/AuthProvider";
import CadastrosIndexEcommerce from "./pages/Painel/Ecommerce/Formularios/index";
import VendasIndex from "./pages/Painel/Ecommerce/vendasIndex";
import ProductDetails from './pages/ProductDetails';
import CartPage from './pages/CartPage';
import Checkout from './pages/Checkout ';
import VendasUserIndex from './pages/Painel/Usuario/vendasUserIndex';
import Blog from './pages/Blog';
import BlogIndex from './pages/Painel/blogIndex';
import BlogList from './pages/BlogIndex';
import Termos from './components/termos';
import CadastroUser from './pages/CadastroUser';
import UserAdminIndex from './pages/Painel/userAdminIndex';
import('slick-carousel/slick/slick.css');
import('slick-carousel/slick/slick-theme.css');


function App() {

  return (
    <Router>
      <div className="App" >
        <Routes>
          <Route path="/novo-pentalobe/*" element={<Navigate to="/" replace />} />
          <Route path="/" element={<Home />} />
          <Route path="/quero-vender" element={<QueroVender />} />
          <Route path="/blog/:slug" element={<Blog />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/quero-comprar" element={<QueroComprar />} />
          <Route path="/carrinho" element={<CartPage />} />
          <Route path="/produto/:sku/:productName" element={<ProductDetails />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/checkout"
            element={
              <ProtectedRoute element={Checkout} requiredRole="" />
            }
          />
          <Route
            path="/index"
            element={
              <ProtectedRoute element={Index} requiredRole="admin" />
            }
          />
          <Route
            path="/usuarios"
            element={
              <ProtectedRoute element={UserAdminIndex} requiredRole="admin" />
            }
          />
          <Route
            path="/cadastros"
            element={
              <ProtectedRoute element={CadastrosIndexEcommerce} requiredRole="admin" />
            }
          />
          <Route
            path="/blog-painel"
            element={
              <ProtectedRoute element={BlogIndex} requiredRole="admin" />
            }
          />
          <Route
            path="/vendas"
            element={
              <ProtectedRoute element={VendasIndex} requiredRole="admin" />
            }
          />
          <Route
            path="/propostas"
            element={
              <ProtectedRoute element={PropostaIndex} requiredRole="admin" />
            }
          />
          <Route
            path="/avaliacoes"
            element={
              <ProtectedRoute element={AvaliacaoIndex} requiredRole="admin" />
            }
          />
          <Route path="/bank-data" element={<BankDataForm />} />
          <Route path="/configuracoes" element={<ConfigIndex />} />
          <Route
            path="/editar-usuario"
            element={
              <ProtectedRoute element={EditUserIndex} requiredRole="user" />
            }
          />
          <Route
            path="/pedidos"
            element={
              <ProtectedRoute element={VendasUserIndex} requiredRole="user" />
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute element={IndexUser} requiredRole="user" />
            }
          />
          <Route
            path="/propostas-user"
            element={
              <ProtectedRoute element={PropostaUserIndex} requiredRole="user" />
            }
          />
          <Route path="/reset-senha" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/termos" element={<Termos />} />
          <Route path="/cadastro-usuario" element={<CadastroUser />} />
        </Routes>
      </div>
    </Router>

  );
}

export default App;
